import { render, staticRenderFns } from "./ChatStat.vue?vue&type=template&id=64b52177&"
import script from "./ChatStat.vue?vue&type=script&lang=js&"
export * from "./ChatStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports